var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[(_vm.icon)?_c('ms-icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"size":_vm.sizeIcon}}):_vm._e(),_vm._t("default"),(_vm.required)?_c('span',{staticClass:"required"},[_vm._v(" * ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }